import React from 'react';
import { useTranslation } from 'react-i18next';

import { useRequestStaffList } from '~/requests/';
import { ConfirmationModal, FitoListReactQuery } from '~/Components';
import { PrivateLayout } from '~/Layout/PrivateLayout';
import { IStaff } from '~/Models/DTO/Staff.model';
import { useStaffList } from '.';

export const StaffList = () => {
  const { t } = useTranslation();

  const {
    keyOfId,
    settings,
    setItemValues,
    tabs,
    tableDefinition,
    handleAddButtonClick,
    defaultQuery,
    actions,
    confirmationModalProps,
  } = useStaffList();

  return (
    <PrivateLayout
      title={{
        title: t('settings.staffMembers'),
        onAddButtonClick: handleAddButtonClick,
        actionName: t('settings.provider.staff.inviteMember'),
      }}
      hideBackButton
    >
      <FitoListReactQuery<IStaff>
        keyOfId={keyOfId}
        settings={settings}
        title={t('settings.staffMembers')}
        setItemValues={setItemValues}
        tableDefinition={tableDefinition}
        defaultQuery={defaultQuery}
        queryResults={useRequestStaffList}
        pageSize={50}
        tabs={tabs}
        searchTextPlaceholder={t('app.search.staff')}
        actions={actions}
      />
      <ConfirmationModal {...confirmationModalProps} />
    </PrivateLayout>
  );
};
